module.exports = __webpack_public_path__ + "img/pen-ruler.077edc05.svg";